import { useQuery } from "@tanstack/react-query";
import { formsService } from "@/services/formsService";

// Query keys
export const formsQueryKeys = {
  all: ["forms"],
  list: () => [...formsQueryKeys.all, "list"],
  details: (id) => [...formsQueryKeys.all, "detail", id],
  personalInfo: () => [...formsQueryKeys.all, "personal-info"],
  jobForms: () => [...formsQueryKeys.all, "job-forms"],
};

// Get all forms
export const useForms = () => {
  return useQuery({
    queryKey: formsQueryKeys.list(),
    queryFn: () => formsService.getAllForms(),
  });
};

// Get a specific form by ID
export const useFormById = (formId) => {
  return useQuery({
    queryKey: formsQueryKeys.details(formId),
    queryFn: () => formsService.getFormById(formId),
    enabled: !!formId, // Only fetch if formId is provided
  });
};

// Get personal info form
export const usePersonalInfoForm = () => {
  return useQuery({
    queryKey: formsQueryKeys.personalInfo(),
    queryFn: () => formsService.getPersonalInfoForm(),
  });
};

// Get job forms
export const useJobForms = () => {
  return useQuery({
    queryKey: formsQueryKeys.jobForms(),
    queryFn: () => formsService.getJobForms(),
  });
};

// Add these query functions
export const usePersonalForms = () => {
  return useQuery({
    queryKey: formsQueryKeys.personalInfo(),
    queryFn: () => formsService.getPersonalInfoForm(),
    select: (data) => data.data // Assuming the API returns data in a 'data' property
  });
};

export const useJobSpecificForms = () => {
  return useQuery({
    queryKey: formsQueryKeys.jobForms(),
    queryFn: () => formsService.getJobForms(),
    select: (data) => data.data // Assuming the API returns data in a 'data' property
  });
};

